import { Injectable, inject } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, of } from "rxjs";
import { catchError } from "rxjs/operators";
import { AppConfig } from "environments/environment";

import pkg from "../../package.json";

interface VersionPayload {
  version: string;
}

@Injectable({
  providedIn: "root",
})
export class VersionService {
  private readonly http = inject(HttpClient);

  private readonly feVersion: string = pkg.version;
  private readonly VERSION_ENDPOINT = `${AppConfig.api}/version`;
  private readonly httpOptions = {
    headers: new HttpHeaders({ "Content-Type": "application/json" }),
  };
  /**
   * Checks if the frontend version matches the backend version.
   * Returns an Observable that emits true if versions match, false otherwise.
   */
  public checkVersionWithBackend(): Observable<boolean> {
    const url = `${this.VERSION_ENDPOINT}?version=${encodeURIComponent(this.feVersion)}`;
    return this.http.get<boolean>(url, this.httpOptions).pipe(
      catchError((err) => {
        console.error("[VersionService] Version check failed:", err);
        return of(false);
      })
    );
  }
}
